export enum OrderFormTestIds {
  SELLER_AUTOCOMPLETE = 'seller-autocomplete',
  ORDER_PRODUCTS_WRAPPER = 'order-products-wrapper',
  SELECT_DELIVERY_WINDOW_BUTTON = 'select-delivery-window-button',
  DELIVERY_WINDOW_ITEM = 'delivery-window-item',
  ORDER_FORM_SECTION_BUTTON = 'order-form-section-button',
  ORDER_FORM_SECTION_ERROR_ICON = 'order-form-section-button-error-icon',
  CUSTOMER_AUTOCOMPLETE = 'customer-autocomplete',
  CUSTOMER_AUTOCOMPLETE_INPUT = 'customer-autocomplete-input',
}
